import { getLoginState } from '@fshr/shared-react/security-cookie';

import type { UserAttributes } from '@optimizely/optimizely-sdk';

export function getPageAttributes(fallbackOwsCode?: string): UserAttributes {
	const propertyInfo = (window as any).FS?.propertyInfo;
	const globalInfo = (window as any).FS?.globalInfo;
	const lang = propertyInfo?.language ?? document.documentElement.lang ?? undefined;
	const property_owsCode = propertyInfo?.owsCode ?? fallbackOwsCode;
	const is_plp = propertyInfo?.isPlp === true;
	// Not property_owsCode, which the CAW fills from the searched hotel on any page.
	const is_property_page = !!propertyInfo?.owsCode;
	const is_preferred_partner =
		window.location.pathname.includes('/preferredpartner') ||
		!!globalInfo?.ppMode ||
		window.location.search.includes('ppMode=true');

	// Always emitted, since areUsersEqual compares the attribute count across providers.
	const login_state = getLoginState();
	const is_authenticated = login_state !== 'anonymous';

	return {
		...(lang ? { lang } : {}),
		...(property_owsCode ? { property_owsCode } : {}),
		is_plp,
		is_property_page,
		is_preferred_partner,
		is_authenticated,
		login_state,
	};
}
